import { render, staticRenderFns } from "./telzxdetmenu.vue?vue&type=template&id=2ab374e9&scoped=true&"
import script from "./telzxdetmenu.vue?vue&type=script&lang=js&"
export * from "./telzxdetmenu.vue?vue&type=script&lang=js&"
import style0 from "./telzxdetmenu.vue?vue&type=style&index=0&id=2ab374e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab374e9",
  null
  
)

export default component.exports